/**
 *  Time in seconds before session expiration to display the countdown notification
 */
export const SESSION_EXPIRATION_COUNTDOWN_TIME = 120;
/**
 * The visibility duration of the session extended/refreshed message
 */
export const SESSION_EXTENDED_MESSAGE_AUTO_HIDE_DURATION = 5000;
// A buffer in seconds to check if current token is a new login
export const NEW_LOGIN_ISSUANCE_BUFFER = 5;
//# sourceMappingURL=session.js.map